import applicationTheme from "@swa-ui/application/theme";
import authenticationTheme from "@swa-ui/authentication/theme";
import { getBootstrapData } from "@swa-ui/bootstrap";
import { initializeColors, initializeTheme } from "@swa-ui/design-tokens";
import dotcomTheme from "@swa-ui/dotcom/theme";
import formTheme from "@swa-ui/form/theme";
import inflightTheme from "@swa-ui/inflight/theme";
import itineraryTheme from "@swa-ui/itinerary/theme";
import placementsTheme from "@swa-ui/placements/theme";

import appTheme from "../theme";

const colorOverrides = getBootstrapData("color-overrides") ?? {};
const themeOverrides = getBootstrapData("theme-overrides") ?? {};

initializeColors(colorOverrides);
initializeTheme({
  dark: {
    ...appTheme.dark,
    ...applicationTheme.dark,
    ...authenticationTheme.dark,
    ...dotcomTheme.dark,
    ...formTheme.dark,
    ...inflightTheme.dark,
    ...itineraryTheme.dark,
    ...placementsTheme.dark,
    ...themeOverrides.dark,
  },
  light: {
    ...appTheme.light,
    ...applicationTheme.light,
    ...authenticationTheme.light,
    ...dotcomTheme.light,
    ...formTheme.light,
    ...inflightTheme.light,
    ...itineraryTheme.light,
    ...placementsTheme.light,
    ...themeOverrides.light,
  },
});
